import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Venue } from './venue';
export { Venue };
import { venueSchema } from '@schemas/business-objects/venue';
import { PositionFormArray } from './position-form-group';
import { TrainingClassFormArray } from './training-class-form-group';

export class VenueFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    address: SchemaFormControl;
    positions: PositionFormArray;
    trainingClasses: TrainingClassFormArray;
  };

  declare value: Partial<Venue>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(venueSchema, Venue, data, options);
  }

  get object(): Venue {
    return new Venue(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'positions':
        return new PositionFormArray();
      case 'trainingClasses':
        return new TrainingClassFormArray();
      default:
        return undefined;
    }
  }
}

export class VenueFormArray extends PersistedFormArray {
  readonly entityName = 'Venue' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(venueSchema, Venue, options);
  }

  protected override createItemGroup() {
    return new VenueFormGroup();
  }

  get array(): Venue[] {
    return this.controls.map((group: VenueFormGroup) => group.object);
  }
}

export class VenuePersistedArray extends PersistedArray<Venue> {
  readonly entityName = 'Venue' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Venue, options);
  }
}
